import { ModuleRendering, SlotRendering } from '@frontend/common-types';
import { Spinner } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { SpotRenderingClient } from '@frontend/spot/api';
import { FormattedMessage } from 'react-intl';

import { ChooseModuleModal } from '../../../components/choose-module-modal/choose-module-modal.component';
import { SpotLayout } from '../../../spot-rendering';
import { ConfirmOpenSlotHint } from '../../components';
import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import usePickUpConfirmOpenSlot from './pick-up-confirm-open-slot.controller';

const ID = 'pick-up-confirm-open-slot';

const PickUpConfirmOpenSlot = () => {
    const viewProps = usePickUpConfirmOpenSlot();

    if (!viewProps.accountId || !viewProps.spotId) {
        return (
            <WizardScreenContainer
                id={ID}
                header={{ title: CommonMessage.BUTTONS.PICK_UP }}
                containerClassName='bg-background-default flex flex-1 flex-col items-center justify-start gap-8 self-stretch overflow-y-scroll p-6 pb-20'>
                <div className='text-foreground-default justify-start text-base font-medium'>
                    <Spinner />
                </div>
            </WizardScreenContainer>
        );
    }

    return (
        <WizardScreenContainer
            id={ID}
            header={{ title: CommonMessage.BUTTONS.PICK_UP }}
            footer={{
                onSubmit: viewProps.onSubmit,
                submitDisabled: viewProps.submitDisabled,
                submitLabel: (
                    <FormattedMessage
                        id='kiosk.wizard.pick-up-confirm-open-slot.open-slot'
                        defaultMessage='Open SLOT'
                        description='Button text to open the slot'
                    />
                )
            }}
            containerClassName='bg-background-default flex flex-1 flex-col items-center justify-start gap-8 self-stretch overflow-y-scroll p-6 pb-20'>
            <ConfirmOpenSlotHint show={!!viewProps.selectedSlot} />

            <SpotLayout<ModuleRendering, SlotRendering>
                renderMode='module'
                fetchSpotData={(arg) => SpotRenderingClient.fetchSpotRendering(viewProps.accountId!, viewProps.spotId!, arg)}
                fetchModuleData={(accountId, spotId, moduleId) => SpotRenderingClient.fetchSpotModuleRendering(accountId, spotId, moduleId)}
                slot={{
                    renderElement: viewProps.slotComponent
                }}
                enableSlotHover={false}
                module={viewProps.currentModule || undefined}
                onModuleNameClick={() => viewProps.setSelectModuleModalOpen(true)}
                onSelectedModuleChange={(moduleId) => {
                    const module = viewProps.modules?.find((m) => m.id === moduleId);
                    if (module) viewProps.setCurrentModule(module);
                }}
            />

            <ChooseModuleModal
                modules={viewProps.modules}
                show={viewProps.selectModuleModalOpen}
                onClose={() => viewProps.setSelectModuleModalOpen(false)}
                onSelectModule={viewProps.setCurrentModule}
            />
        </WizardScreenContainer>
    );
};

export default PickUpConfirmOpenSlot;
